import React, { FunctionComponent } from 'react'
import { Badge, Card, Col, List, Row } from 'antd'
import { useQuery } from '@tanstack/react-query'
import { useFeathersClient } from '@strac/react-client-feathers'
import useQueryListener from '../../../hooks/data/useQueryListener'
import { formatTimestamp, fromNow } from '../../../utils/time'
import moment from 'moment-timezone'

const ActiveUsers: FunctionComponent<any> = () => {
  const client = useFeathersClient()

  const {
    data: connected,
    isLoading: connectedLoading,
    refetch: refetchConnected
  } = useQuery({
    queryKey: ['active-users', 'find', { type: 'connected' }],
    queryFn: async () => client.service('active-users').find({ query: { type: 'connected' } }),
    placeholderData: []
  })

  useQueryListener('active-users', refetchConnected)

  const customSort = (a: any, b: any) => {
    return moment(b[1].created_at).unix() - moment(a[1].created_at).unix()
  }

  const connectedIps = connected.sort(customSort).map((connection: any) => {
    return connection[0]
  })

  const {
    data: authenticated,
    isLoading: authenticatedLoading,
    refetch: refetchAuthenticated
  } = useQuery({
    queryKey: ['active-users', 'find', { type: 'authenticated' }],
    queryFn: async () => client.service('active-users').find({ query: { type: 'authenticated' } }),
    placeholderData: []
  })

  useQueryListener('active-users', refetchAuthenticated)

  const authenticatedUsers = authenticated.sort(customSort).map((connection: any) => {
    return connection[1]
  })

  return (
    <Col span={18}>
      <Card variant={'outlined'} title={'User Sessions'}>
        <Row style={{ margin: '24px' }} gutter={[12, 12]} justify={'center'}>
          <Col span={24}>
            <List
              bordered={true}
              loading={authenticatedLoading || connectedLoading}
              dataSource={authenticatedUsers}
              renderItem={(connection: any) => {
                return (
                  <List.Item
                    extra={<Badge color={connectedIps.includes(connection?.ip) ? 'green' : 'yellow'} />}
                  >
                    <List.Item.Meta
                      title={`${connection?.access_code} @ ${connection?.ip}`}
                      description={
                        <span>
                          <span>{`Created: ${formatTimestamp(connection?.iat, 'HH:mm A')}`}</span>
                          <br />
                          <span>{`Expires: ${fromNow(connection?.expiration)}`}</span>
                        </span>
                      }
                    />
                  </List.Item>
                )
              }}
            />
          </Col>
        </Row>
      </Card>
    </Col>
  )
}

export default ActiveUsers
